import { Injectable, inject } from '@angular/core';
import { UserApiService } from '@api-new/userservice';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { getAdviserDetail, getAdviserDetailFailure, getAdviserDetailSuccess } from '@shared/store/adviser/adviser.actions';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class AdviserEffects {
  private readonly userApiService = inject(UserApiService);
  private readonly actions$ = inject(Actions);

  getAdviserDetail: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(getAdviserDetail),
      switchMap(() => {
        return this.userApiService.HTTP_CP_GetAdvisorUser().pipe(
          map((adviser) => getAdviserDetailSuccess({ adviser })),
          catchError((error) => {
            console.error(error);
            return of(getAdviserDetailFailure(error));
          }),
        );
      }),
    ),
  );
}
